(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
  $('.docs-nav-list a').each(function () {
    if (window.location.href == $(this).attr('href')) {
      var $dropdown = $(this).parents('.docs-nav-children');
      toggleDropdown($dropdown, 0);
      $dropdown.siblings('a').addClass('is-active');
      $(this).toggleClass('is-active');
    }
  });
  $('.docs-nav-list .has-children > a').click(function (e) {
    e.preventDefault();
    var $dropdown = $(this).siblings('.docs-nav-children');
    toggleDropdown($dropdown, 250);
    $(this).toggleClass('is-active');
  });
});

function toggleDropdown($dropdown, duration) {
  if ($dropdown.data('is-open') === false) {
    $dropdown.velocity('slideDown', {
      duration: duration
    });
    $dropdown.data('is-open', true);
  } else {
    $dropdown.velocity('slideUp', {
      duration: duration
    });
    $dropdown.data('is-open', false);
  }
}

},{}]},{},[1]);
